import { useEffect, useState } from 'react';

export const useMobileViewport = (breakpoint = 768): boolean => {
  const [isMobileViewport, setIsMobileViewport] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const handleResize = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(() => {
        setIsMobileViewport(window.innerWidth < breakpoint);
        console.log('Viewport width:', window.innerWidth, 'isMobileViewport:', window.innerWidth < breakpoint);
      }, 250);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [breakpoint]);

  return isMobileViewport;
};
